import { render, staticRenderFns } from "./DynamicSelectInput.vue?vue&type=template&id=5980202a"
import script from "./DynamicSelectInput.vue?vue&type=script&lang=js"
export * from "./DynamicSelectInput.vue?vue&type=script&lang=js"
import style0 from "./DynamicSelectInput.vue?vue&type=style&index=0&id=5980202a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports